export default {
  'error-page.title': 'Ошибка загрузки конфигурации CMS',
  'error-page.body': '<p>Файл <code>config.yml</code> не может быть загружен или его не удалось прочитать.</p>'
    + '<p><strong>Текст ошибки:</strong> {error}</p>',
  'side-bar.search-all': 'Поиск',
  'side-bar.collections': 'Категории',
  'app.waiting': 'Загрузка данных...',
  'header.content': 'Разделы',
  'header.workflow': 'Доска',
  'header.media': 'Медиа',
  'header.quick-add': 'Добавить',
  'header.log-out': 'Выход',
  'collection.new': 'Создать',
  'collection.view-as': 'Вид',
  'entry.delete': 'Удалить',
  'entry.publish': 'Опубликовать',
  'entry.published': 'Опубликовано',
  'entry.publishing': 'Публикация...',
  'entry.publish-now': 'Опубликовать',
  'entry.publish-and-create-new': 'Опубликовать и создать новую запись',
  'entry.save': 'Сохранить',
  'entry.saving': 'Сохранение...',
  'entry.deleting': 'Удаление...',
  'entry.updating': 'Сохранение...',
  'entry.set-status': 'Cтатус',
  'entry.draft': 'Черновик',
  'entry.in-review': 'На проверке',
  'entry.ready': 'Готово',
  'entry.header': 'Редактировать раздел <strong>{label}</string>',
  'entry.log-out': 'Выход',
  'entry.unsaved-changes': 'Есть несохранённые изменения',
  'entry.changes-saved': 'Изменения сохранены',
  'entry.delete-changes': 'Удалить неопубликованные изменения',
  'entry.delete-entry': 'Удалить неопубликованные данные',
  'entry.delete-pub-entry': 'Удалить опубликованные данные',
  'entries.loading': 'Загрузка раздела',
  'entries.caching': 'Кеширование раздела',
  'entries.waiting': 'Это может занять пару минут',
  'entries.no': 'Нет данных',
};



// WEBPACK FOOTER //
// ./translations/ru.js